import {
  SET_CLIENT_DETAILS,
  SET_CLIENT_DETAILS_FAILED,
  SET_CLIENT_DETAILS_START,
  SET_CLIENT_TAGS,
  SET_JOURNALIST_ACCESS,
  SET_SELECTED_CLIENT_DETAILS,
  SET_FEED_TAGS_START,
  SET_FEED_TAGS_FINISH,
  SET_FEED_TAGS_FAILED,
  SET_AUTH,
  SET_CLIENT_QUALITATIVE_SETTINGS,
  SET_USER_PASSWORD_DETAILS,
  SET_CLIENT_MASTER,
  SET_CLIENT_SUB_USER,
  SET_CLIENT_MASTER_LIST,
  SET_STATE,
  SET_CLIENT_LANGUAGE,
  SET_CLIENT_SUB_USER_FILTER_DATA
} from "../actions/actionTypes";

const initialState = {
  clientsToUser: [],
  selectedClient: {},
  clientTagData: {},
  feedTagList: {
    isLoading: false,
    error: null,
    data: [],
  },
  isAuth: {
    result: true,
    message: null,
  },
  qualitativeSettings: {
    qualitative: false,
    settings: [],
    message: null,
    isVertical: false,
    verticals: [],
  },
  passwordData:{},
  masterUser : undefined,
  masterUsers : {},
  subUser : [],
  clientLanguage : [],
  state : [],
  subUserStatus : false,
  subUserFilterData : []
};

export const clientReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_AUTH:
      const result = payload.result.valid;
      return {
        ...state,
        isAuth: {
          result: result,
          message: payload.messsage,
        },
        isLoading: false,
      };
    case SET_CLIENT_DETAILS:
      return { ...state, clientsToUser: payload, isLoading: false };

    case SET_SELECTED_CLIENT_DETAILS:
      return { ...state, selectedClient: payload };

    case SET_USER_PASSWORD_DETAILS:
      return { ...state, passwordData: payload };

    case SET_CLIENT_DETAILS_FAILED:
      return { ...state, error: payload, isLoading: false };

    case SET_CLIENT_DETAILS_START:
      return { ...state, isLoading: true };
    case SET_CLIENT_TAGS:
      return { ...state, clientTagData: payload };
    case SET_CLIENT_QUALITATIVE_SETTINGS:
      return { ...state, qualitativeSettings: payload };
    case SET_JOURNALIST_ACCESS:
      return { ...state, allowJournalistAccess: payload };
    case SET_FEED_TAGS_START: {
      const existingData = state.feedTagList.data;
      return {
        ...state,
        feedTagList: {
          isLoading: !existingData.length,
          data: existingData,
        },
      };
    }
    case SET_FEED_TAGS_FINISH:
      return { ...state, feedTagList: { data: payload } };

    case SET_FEED_TAGS_FAILED:
      return { ...state, feedTagList: { error: payload } };
    case SET_CLIENT_MASTER:
      return {
        ...state,
        masterUser: payload,
      };
    case SET_CLIENT_MASTER_LIST:
      return {
        ...state,
        masterUsers: payload,
      };
    case SET_CLIENT_SUB_USER:
      return {
        ...state,
        subUser: payload,
      };
    case SET_CLIENT_SUB_USER_FILTER_DATA:
      return {
        ...state,
        subUserFilterData: payload,
        subUserStatus: true
      };
    case SET_STATE:
      return {
        ...state,
        state: payload,
      };
    case SET_CLIENT_LANGUAGE:
      return {
        ...state,
        clientLanguage: payload,
      };
    default:
      return state;
  }
};
